// billing-plugin/common/schemas/collections/billingTransactions.js
import { z } from "zod";

const BillingTransactionActionSchema = z.object({
    type: z.enum([
        'CREATE_CHARGEABLE',
        'CREATE_CHARGE_RECORD',
        'DECREMENT_BALANCE',
        'INCREMENT_USAGE'
    ]),
    data: z.record(z.any()),
});

const BillingTransactionSchema = z.object({
    _id: z.string().optional(),
    reservationId: z.string().uuid(),
    targetId: z.string().describe("The subscriptionId."),
    status: z.enum(['reserved', 'committed', 'cancelled']).default('reserved'),
    actions: z.array(BillingTransactionActionSchema),
    reservedAt: z.coerce.date(),
    committedAt: z.coerce.date().optional().nullable(),
    cancelledAt: z.coerce.date().optional().nullable(),
});

export default BillingTransactionSchema;